<div class="form-group calendar">
  <div class="d-flex">
    <label for="dateRange" class="w-100">{{ dateLabel }}</label>
  </div>
  <div
    class="form-control w-100 calendar__input"
    [ngClass]="{
      'calendar__input--open': isOpen,
      'calendar__input--compact': compact
    }"
    [attr.data-qa]="testIdPrefix + '-input'"
  >
    <rx-icon name="calendar" class="calendar__icon mr-1"  />
    <input
      type="text"
      placeholder="{{ placeholder }}"
      name="dateRange"
      value="{{ fromDate | date : dateFormat }} - {{ toDate | date : dateFormat }}"
      id="dateRange"
      readonly
      [attr.data-qa]="testIdPrefix + '-dates-selected'"
    />
    <rx-icon [hidden]="isOpen" name="chevron-down" fill="primary" class="calendar__icon" />
    <rx-icon [hidden]="!isOpen" name="chevron-up" fill="primary" class="calendar__icon" />
  </div>
  <ng-content select="[rx-error]"></ng-content>
</div>
